/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module L4PolicyModule */

import {
    Component,
    Input,
} from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import { SchemaService } from 'ajs/modules/core/services/schema-service';
import {
    L4RulePortMatchConfigItem,
} from 'ajs/modules/l4-policy/factories/matches/l4-rule-port-match.config-item.factory';
import * as l10n from './l4-rule-port-match-readonly.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component to show readonly information for L4RulePortMatch.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'l4-rule-port-match-readonly',
    templateUrl: './l4-rule-port-match-readonly.component.html',
})
export class L4RulePortMatchReadonlyComponent {
    @Input()
    public editable: L4RulePortMatchConfigItem;

    public readonly l10nKeys = l10nKeys;

    constructor(
        l10nService: L10nService,
        private readonly schemaService: SchemaService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Convenience method to get text label for selected match criteria.
     */
    public get matchCriteria(): string {
        return this.schemaService.getEnumValueLabel(
            'MatchOperation',
            this.editable.config.match_criteria,
        );
    }
}
